import { useGetListWallet } from "../../api/wallet";

export const useWalletManagement = (
  companyId: number,
  params: { start: number; end: number },
  name?: string,
  currencyId?: number,
  ignoreId?: string
) => {
  const {
    data = {
      data: {
        data: { total: 0, pageSize: 10, page: 1, totalPages: 1, items: [] },
      },
    },
    isLoading,
    refetch,
  } = useGetListWallet({
    companyId,
    ...params,
    name,
    currencyId,
    ignoreId,
  });
  return { dataListWallet: data.data.data, isLoading, refetch };
};
